@if (wrapInListItem()) {
  @for (item of counter(count()); track $index) {
    <li class="product-card-skeleton__list-item">
      @if (compact()) {
        <div class="product-card-skeleton product-card-skeleton--listing">
          <div class="product-card-skeleton__listing-media">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                height: '100%',
                'border-radius': '0',
                margin: '0',
              }"></ngx-skeleton-loader>
            <div class="product-card-skeleton__listing-code">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '3.5rem',
                  height: '1.25rem',
                  'border-radius': '0.375rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
            </div>
          </div>

          <div class="product-card-skeleton__listing-info">
            <div class="product-card-skeleton__listing-text">
              <ngx-skeleton-loader
                count="1"
                class="product-card-skeleton__listing-title"
                [theme]="{
                  width: '78%',
                  height: '0.875rem',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
              <ngx-skeleton-loader
                count="1"
                class="product-card-skeleton__listing-subtitle"
                [theme]="{
                  width: '52%',
                  height: '0.75rem',
                  'border-radius': '0.25rem',
                  margin: '0.25rem 0 0 0',
                }"></ngx-skeleton-loader>
            </div>
          </div>

          <div class="product-card-skeleton__listing-footer">
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-price-label"
              [theme]="{
                width: '2.5rem',
                height: '0.625rem',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-price-value"
              [theme]="{
                width: '4.5rem',
                height: '0.875rem',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>
      } @else {
        <div class="product-card-skeleton">
          <div class="product-card-skeleton__flex">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '4em',
                height: '1.5em',
                'border-radius': '0.25em',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '1.5em',
                height: '1.5em',
                'border-radius': '0.25em',
              }"></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="1"
            class="product-card-skeleton__image-loader"
            [theme]="{
              width: '16.5em',
              height: '16.75em',
              'border-radius': '0.625em',
              'margin-bottom': '1.25em',
            }"></ngx-skeleton-loader>
          <div class="product-card-skeleton__flex">
            <pwj-card-property-skeleton [count]="1"></pwj-card-property-skeleton>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '3em',
                height: '1.5em',
                'border-radius': '0.25em',
                'margin-top': '0.375em',
              }"></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="2"
            [theme]="{
              height: '1.5em',
              'border-radius': '0.25em',
              margin: '0',
            }"></ngx-skeleton-loader>
        </div>
      }
    </li>
  }
} @else {
  <div [ngClass]="containerClasses()">
    @for (item of counter(count()); track $index) {
      @if (compact()) {
        <div class="product-card-skeleton product-card-skeleton--listing">
          <div class="product-card-skeleton__listing-media">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                height: '100%',
                'border-radius': '0',
                margin: '0',
              }"></ngx-skeleton-loader>
            <div class="product-card-skeleton__listing-code">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '3.5rem',
                  height: '1.25rem',
                  'border-radius': '0.375rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
            </div>
          </div>

          <div class="product-card-skeleton__listing-info">
            <div class="product-card-skeleton__listing-text">
              <ngx-skeleton-loader
                count="1"
                class="product-card-skeleton__listing-title"
                [theme]="{
                  width: '78%',
                  height: '0.875rem',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
              <ngx-skeleton-loader
                count="1"
                class="product-card-skeleton__listing-subtitle"
                [theme]="{
                  width: '52%',
                  height: '0.75rem',
                  'border-radius': '0.25rem',
                  margin: '0.25rem 0 0 0',
                }"></ngx-skeleton-loader>
            </div>
          </div>

          <div class="product-card-skeleton__listing-footer">
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-price-label"
              [theme]="{
                width: '2.5rem',
                height: '0.625rem',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              class="product-card-skeleton__listing-price-value"
              [theme]="{
                width: '4.5rem',
                height: '0.875rem',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>
      } @else {
        <div class="product-card-skeleton">
          <div class="product-card-skeleton__flex">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '4em',
                height: '1.5em',
                'border-radius': '0.25em',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '1.5em',
                height: '1.5em',
                'border-radius': '0.25em',
              }"></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="1"
            class="product-card-skeleton__image-loader"
            [theme]="{
              width: '16.5em',
              height: '16.75em',
              'border-radius': '0.625em',
              'margin-bottom': '1.25em',
            }"></ngx-skeleton-loader>
          <div class="product-card-skeleton__flex">
            <pwj-card-property-skeleton [count]="1"></pwj-card-property-skeleton>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '3em',
                height: '1.5em',
                'border-radius': '0.25em',
                'margin-top': '0.375em',
              }"></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="2"
            [theme]="{
              height: '1.5em',
              'border-radius': '0.25em',
              margin: '0',
            }"></ngx-skeleton-loader>
        </div>
      }
    }
  </div>
}
